
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Grid,
} from "@mui/material";
import React, { FC, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Telo } from "../../../../../models/pergola_configuration";


export type TeloDialogProps = {
  teli: Telo[];
  selectedTelo: string | null;
  onConfirm: (value: string | null) => void;
  onCancel: () => void;
};

export const TeloDialog: FC<TeloDialogProps> = ({
  teli,
  selectedTelo,
  onConfirm,
  onCancel,
}) => {
  const [value, setValue] = useState<Telo | undefined>(
    teli.find((t) => t.code === selectedTelo)
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleConfirm = () => {
    onConfirm(value?.code ?? null);
  };

  return (
    <Dialog
      fullWidth={false}
      fullScreen={fullScreen}
      maxWidth="sm"
      onClose={onCancel}
      open={true}
    >
      <DialogTitle>Seleziona il codice telo</DialogTitle>
      <DialogContent sx={{ py: 2 }}>
        <Grid container spacing={2} className="dialog-colors-grid" sx={{ my: 0 }}>
          {teli.map((t) => (
            <Grid
              key={t.code}
              item
              md={teli.length === 1 ? 12 : 6}
              onClick={() => setValue(t)}
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                borderRadius: 2,
                backgroundColor: value?.code === t.code ? "#e3f2fd" : "transparent",
                border: value?.code === t.code ? "2px solid #1976d2" : "1px solid transparent",
                transition: "background-color 0.2s, border 0.2s",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
              }}
            >
              {t.img ? (
                <img
                  src={t.img}
                  alt={t.code}
                  style={{ width: "4rem", height: "4rem" }}
                />
              ) : (
                <div
                  style={{
                    width: "4rem",
                    height: "4rem",
                    backgroundColor: "#ddd",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "0.7rem",
                    color: "#666",
                  }}
                >
                  No Img
                </div>
              )}

              <div style={{ paddingLeft: "1rem" }}>
                <h6 style={{ margin: 0, color: "#666" }}>{t.code}</h6>
              </div>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onCancel}>
          Annulla
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
